import React from 'react';
import styled from 'styled-components';
import { createTimeInstance } from '@utils/time';
import { Body5, Body7, Container } from '@ui';
import { TransparentFlatButton } from '@ui/buttons';
import { Working } from '@ui/Working';

const RowWrapper = styled.div`
  padding: 12px 0;
  border-bottom: 1px solid ${({ theme }) => theme.themeColors.lowContrastBorder};
`;
const PrefixText = styled(Body7)`
  font-family: monospace;
`;
const ExpiredTag = styled.span`
  margin-left: 8px;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
  color: ${({ theme }) => theme.themeColors.error};
  border: 1px solid ${({ theme }) => theme.themeColors.error};
`;

const formatDate = (value) => createTimeInstance(value)?.format('MMM D, YYYY');

const isExpired = (expires_at) => !!expires_at && createTimeInstance(expires_at).isBefore(createTimeInstance());

export const ApiKeyRow = ({ apiKey, isRevoking, onRequestRevoke }) => {
  const expired = isExpired(apiKey.expires_at);
  const lastUsed = apiKey.last_used_at ? `last used ${formatDate(apiKey.last_used_at)}` : 'never used';
  const expiry = apiKey.expires_at ? `expires ${formatDate(apiKey.expires_at)}` : 'never expires';

  return (
    <RowWrapper>
      <Container row verticallyCenter spaceBetween>
        <Container row>
          <Body5 bold>
            {apiKey.name}
            {expired && <ExpiredTag>expired</ExpiredTag>}
          </Body5>
          <Container left={4}>
            <PrefixText isLowContrast>{apiKey.prefix}</PrefixText>
          </Container>
        </Container>

        {isRevoking ? (
          <Working noVerticalPadding />
        ) : (
          <TransparentFlatButton onClick={() => onRequestRevoke(apiKey)}>Revoke</TransparentFlatButton>
        )}
      </Container>

      <Container top={4}>
        <Body7 isLowContrast>
          created {formatDate(apiKey.created_at)} · {lastUsed} · {expiry}
        </Body7>
      </Container>
    </RowWrapper>
  );
};
